import {Component, Input} from '@angular/core';
import {Language} from "../../shared/language.enum";
import {SwitchLanguageService} from "./switch-language.service";

@Component({
    selector: 'app-switch-language',
    templateUrl: './switch-language.component.html',
    styleUrls: ['./switch-language.scss'],
    standalone: false
})
export class SwitchLanguageComponent {
  public Language = Language;

  @Input() centered = false;

  constructor(
    public switchLanguageService: SwitchLanguageService,
  ) {
  }

  switchLanguage(language: Language): void {
    this.switchLanguageService.switchLanguage(language);
  }

  isLanguageSelected(language: Language): boolean {
    return this.switchLanguageService.isLanguageSelected(language);
  }

}
